import React from 'react'

const ManageNews = () => {
  return (
    <div
    style={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "2rem",
    }}
  >
    Under Development
  </div>
  )
}

export default ManageNews